export default __webpack_public_path__ + "images/b57ee62d7d2a69e9ad729b38be577501.svg";